import CircularProgress from '@material-ui/core/CircularProgress'
import PropTypes from 'prop-types'

import './styles.less'

const CircularProgressBar = ({ size, thickness }) => {
  return (
    <div className='tabeeb-circular-progress-bar'>
      <CircularProgress size={size} thickness={thickness} />
    </div>
  )
}

CircularProgressBar.propTypes = {
  size: PropTypes.number,
  thickness: PropTypes.number,
}

export default CircularProgressBar
